import styled from 'particles/themes/styled'

export const TemplateFormContainer = styled.div`
    background: white;
    max-width: 770px;
    display: flex;
    flex-direction: column;
    gap: ${({ theme }) => theme.spacing[600]};
    overflow-y: auto;
    padding-bottom: 30px;

    .button-group {
        display: flex;
        gap: ${({ theme }) => theme.spacing[500]};

        .button {
            width: fit-content;
        }
    }
`
export const FieldContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: ${({ theme }) => theme.spacing[600]};
`

export const StickerTextContainer = styled.div`
    background: ${({ theme }) => theme.colors.surface.infoPastel};
    border-radius: 12px;
    width: 600px;
    border: 1px solid ${({ theme }) => theme.colors.border.primary};
    padding: 12px;
`
